import { ResourceManager } from 'libs/abc/core/resources/src';

const res = ResourceManager.getResources('abc-ui-components-abcGrid');
export class AbcGridDefaultContextMenu {
  constructor() {
    new ResourceManager();
  }
  rmvSort = res('ContextMenu-RemoveSorts');
  addcolumn = res('ContextMenu-AddNewDataColumn');
  columnselection = res('ContextMenu-ColumnChooser');
  paste = res('ContextMenu-PasteValueFromClipboard');
  copy = res('ContextMenu-CopyColumnToClipboard');
  excel = res('ContextMenu-ExportToExcel');
  more = res('ContextMenu-MoreOptions');
  get group() {
    return {
      id: 'ContextMenu-GroupBy',
      enable: res('ContextMenu-GroupBy-Enable'),
      disable: res('ContextMenu-GroupBy-Disable'),
      position: 0,
      name: 'groupable',
    };
  }
  get filterHeader() {
    return {
      id: 'ContextMenu-HeaderFilter',
      enable: res('ContextMenu-HeaderFilter-Enable'),
      disable: res('ContextMenu-HeaderFilter-Disable'),
      position: 1,
      name: 'columnFilter',
    };
  }
  get filterBuilder() {
    return {
      id: 'ContextMenu-FilterBuilder',
      enable: res('ContextMenu-FilterBuilder-Enable'),
      disable: res('ContextMenu-FilterBuilder-Disable'),
      position: 2,
      name: 'filterPanel',
    };
  }
  get filterRow() {
    return {
      id: 'ContextMenu-FilterRow',
      enable: res('ContextMenu-FilterRow-Enable'),
      disable: res('ContextMenu-FilterRow-Disable'),
      position: 3,
      name: 'showfilterrow',
    };
  }
  get selectionMode() {
    return {
      id: 'ContextMenu-Selection',
      enable: res('ContextMenu-MultipleSelection'),
      disable: res('ContextMenu-SingleSelection'),
      position: 4,
      name: 'selectionMode',
    };
  }
  get totalCount() {
    return {
      id: 'ContextMenu-TotalCount',
      enable: res('ContextMenu-TotalCount-Enable'),
      disable: res('ContextMenu-TotalCount-Disable'),
      position: 5,
      name: 'summary',
    };
  }
  get columnResizing() {
    return {
      id: 'ContextMenu-ColumnResizing',
      enable: res('ContextMenu-ColumnResizing-Enable'),
      disable: res('ContextMenu-ColumnResizing-Disable'),
      position: 6,
      name: 'columnResize',
    };
  }

  // constructor() {
  //     Object.assign(this);
  // }
}
export enum AbcGridDefaultContextMenuIconsPath {
  rmvSort = 'assets/resources/abc-ui-components-abcGrid/RemoveAllSortWebArena.svg',
  addColumn = 'assets/resources/abc-ui-components-abcGrid/AddNewDataWebArena.svg',
  columnSelection = 'assets/resources/abc-ui-components-abcGrid/ColumnSelectionWebArena.svg',
  paste = 'assets/resources/abc-ui-components-abcGrid/GetValueWebArena.svg',
  copy = 'assets/resources/abc-ui-components-abcGrid/CopyColumnWebArena.svg',
  excel = 'assets/resources/abc-ui-components-abcGrid/ExportDataWebArena.svg',
  more = 'assets/resources/abc-ui-components-abcGrid/MoreOptions.svg',
  groupBy = 'assets/resources/abc-ui-components-abcGrid/GroupByWebArena.svg',
  headerFilter = 'assets/resources/abc-ui-components-abcGrid/FilterWebArena.svg',
  filterBuilder = 'assets/resources/abc-ui-components-abcGrid/FilterRowWebArena.svg',
  filterRow = 'assets/resources/abc-ui-components-abcGrid/FilterBuilderWebArena.svg',
  multiSelection = 'assets/resources/abc-ui-components-abcGrid/EnableCheckboxWebArena.svg',
  totalCount = 'assets/resources/abc-ui-components-abcGrid/TotalCount.svg',
}

export enum AbcGridColumnsLine {
  None = 'none',
  Line = '1px solid rgba(115, 140, 155, 0.6)',
}

export enum AbcGridGroupBy {
  None = 'none',
  Block = 'block',
}
